import { Icon } from './hbs/Icon';

export default function ContactsEmptyPanel(): JSX.Element {
  return (
    <div className="h-full flex flex-col items-center justify-center text-center p-8 text-hbs-text-mute">
      <Icon name="contact" size={56} className="text-hbs-text-mute mb-3" />
      <h2 className="font-display text-[20px] text-hbs-text mb-1">Select a contact</h2>
      <p className="text-[13px] max-w-xs">
        Choose a contact from the list to see their details, or add a new one with the + button.
      </p>
    </div>
  );
}
